import '../social_content_context_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.TikTokContentContextView extends Monitoring.Views.SocialContentContextView

  newSearch: =>
    contextClasses = []
    contextClasses.push Monitoring.Views.TikTokContentParentPostView
    contextClasses.push Monitoring.Views.TikTokContentPreviousCommentsView if !@socialContent.isPost()
    contextClasses.push Monitoring.Views.TikTokContentFollowingCommentsView

    _.each(contextClasses, (contextClass) =>
      new contextClass({el: @$el, socialContent: @socialContent}).fetch()
    )
    @show()
